import { createSlice } from "@reduxjs/toolkit"
import { setAttribute } from "../estoque/EstoqueSlice";

const initialState = {
    loading: true,
    exibeTestes: false,
    respostas : []
}
export const relatorioSlice = createSlice({
    name: "relatorio",
    initialState,
    reducers: {
        triggerLoadRelatorio: () => {},
        setAttributeRelatorio : (state, action) => {
            state[action.payload.campo] = action.payload.value
        }
    }})

export const {
    triggerLoadRelatorio,
    setAttributeRelatorio,
} = relatorioSlice.actions;


export default relatorioSlice.reducer;